import authHeader from "../../../../services/auth-header";
import axios from "axios";
import { BASE_URL, NODE_BASE_URL } from "../../../../config/siteUrls";
import { getFromLocalStorage } from "../../../../utils/webStorage";
export default async (editedVideoName, imageUrl, inputVideoPath) => {
  const userId = getFromLocalStorage("currentUserId");
  const data = {
    inputVideoPath,
    editedVideoName,
    userId,
  };
  const imageResponse = await fetch(imageUrl);
  const imageBlob = await imageResponse.blob();
  const formData = new FormData();
  formData.append("image", imageBlob, "themeImage.png");
  formData.append("json_data", JSON.stringify(data));
  const response = await axios.post(NODE_BASE_URL + "/video/theme", formData, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
